<template>
    <QuestionSearch :question="question" :questionId="questionId" @questionSelected="questionSelected" />
</template>

<script>
import QuestionSearch from "@/views/zhiji/components/questionSearch/QuestionSearch";

export default {
    name: "QuestionSelect",
    props: ["value"],
    components: {
        QuestionSearch
    },
    data() {
        const val = this.value || {};
        return {
            question: val.question,
            questionId: val.questionId
        };
    },
    watch: {
        value() {
            const val = this.value || {};
            this.question = val.question;
            this.questionId = val.questionId;
        }
    },
    methods: {
        questionSelected(data) {
            this.selectedQues = data;
            this.$emit("input", data);
        }
    }
};
</script>

<style></style>
